import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from '@atlassian/help-center-common-component/with-async';

export const ExternalLinks = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "external-links" */ './external-links')),
    LoadingSkeleton: () => null,
});
